
import { LanguageService } from './../../../Services/languageService';
import { restURL } from './../../../Models/restURL';
import { Router } from '@angular/router';
import { MedmalBindMdl } from './../../../Models/MedmalBindMdl';
import { Subscription } from 'rxjs';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { MedmalProposal } from '../../../Models/MedmalProposal';
import { mdlPayloadRequest } from '../../../Models/mdlPayloadRequest';
import { mdlPayloadResponse } from '../../../Models/mdlPayloadResponse';
import Swal from 'sweetalert2';
import { EncryptionService } from '../../../Services/EncryptionService';
import { APIService } from '../../../Services/api.service';

@Component({
  selector: 'MedmalNewProposalConfirm',
  templateUrl: './MedmalNewProposalConfirm.html',
  styleUrls: ['./MedmalNewProposalConfirm.css']
})
export class MedmalNewProposalConfirm {
  public httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
  public isShowLoading: boolean = false;
  public LngSubscription: Subscription;
  public medmalBindObj: MedmalBindMdl = new MedmalBindMdl();
  public proposalObj: MedmalProposal = new MedmalProposal();
  public Lng: string;
  public isError: boolean;
  public IsPromoApplied: boolean = false;
  public objPayloadRequest: mdlPayloadRequest = new mdlPayloadRequest();
  public objPayloadResponse: mdlPayloadResponse = new mdlPayloadResponse();

  public showAddiLoad:boolean= false;


  constructor(private APISer: APIService,private EncriptService: EncryptionService, private router: Router, private http: HttpClient, private url: restURL, 
    private lngService: LanguageService) {

   
    this.LngSubscription = this.lngService.grtLng().subscribe(lng => { this.Lng = lng });
    this.isError = false;
    this.IsPromoApplied = false;
    // this.isError=false;
    if (sessionStorage.getItem("Language") != null) {
      let Language:any= sessionStorage.getItem("Language")
      this.Lng = Language;
    }
    else {
      this.Lng = "en";
    }
    if (sessionStorage.getItem("medmalProposalObj") != null) {
      let medmalProposalObj:any= sessionStorage.getItem("medmalProposalObj")
      this.proposalObj = JSON.parse(this.EncriptService.DecriptObject(medmalProposalObj));
      this.BindPremium();
      if (this.proposalObj.PromoDiscount > 0) {
        this.IsPromoApplied = true;
      }
    }
    else {
      this.router.navigate(['Menu/MedmalNewProposal']);

    }
    let UseriD:any=sessionStorage.getItem("UserId")
    this.medmalBindObj.proposalObj.UserID= JSON.parse(this.EncriptService.DecriptObject(UseriD));
    this.proposalObj.UserID= JSON.parse(this.EncriptService.DecriptObject(UseriD));
    // this.proposalObj.UserID="331";

  }

  Proceed() {
    sessionStorage.setItem("medmalProposalObj", this.EncriptService.EncriptObject(JSON.stringify(this.proposalObj)));
    this.router.navigate(['NewDashboard/MedmalInsuredInfo']);
  }
  CancelProceed() {
    this.router.navigate(['NewDashboard/MedmalNewProposal']);
  }



  async ApplyPromo() {

    this.medmalBindObj.proposalObj = this.proposalObj;

    this.isShowLoading = true;
    var APIRes = await this.APISer.ConnectAPI("/LimraMedmal/ApplyMedmalPromoCode", this.proposalObj)
    this.isShowLoading = false;
    var APIStatus = APIRes[0]
    if (APIStatus.StatusCode == "F") {
      Swal(APIStatus.StatusDesc, "", "error")
      return;
    }
    this.proposalObj = APIRes[1];
  
    if(APIRes[1].StatusCode=="F"){
      Swal(APIRes[1].StatusDesc, "", "error")
    }
      if (this.proposalObj.st.StatusCode == "S") {
        this.IsPromoApplied = true;
        this.isShowLoading = false;
        sessionStorage.setItem("medmalProposalObj", this.EncriptService.EncriptObject(JSON.stringify(this.proposalObj)));
        this.Lng == "en" ? Swal(this.proposalObj.st.StatusDescEn) : Swal(this.proposalObj.st.StatusDescAr);
        this.BindPremium();
      }
      else {
        this.isShowLoading = false;
        this.Lng == "en" ? Swal(this.proposalObj.st.StatusDescEn) : Swal(this.proposalObj.st.StatusDescAr);
        this.proposalObj.PromoCode = '';
      }

  }


  BindPremium() {
    this.proposalObj.DeductableLoadPer = 0; this.proposalObj.DeductableLoadAmt = 0; this.proposalObj.ExtPeriodLoadPer = 0;
    this.proposalObj.ExtPeriodLoadAmt = 0; this.proposalObj.RetroDateLoadPer = 0; this.proposalObj.RetroDateLoadAmt = 0;
    this.proposalObj.AddRetroDateLoadPer = 0; this.proposalObj.AddRetroDateLoadAmt = 0; this.proposalObj.BasicPremium = 0;
    this.proposalObj.Grosspremium = 0; this.proposalObj.DiscountAmount = 0; this.proposalObj.DiscountPercentage = 0;
    this.proposalObj.CrossSellDiscountAmt = 0; this.proposalObj.CrossSellDiscountPer = 0; this.proposalObj.PromoDiscount = 0;
    this.proposalObj.PromoDiscountPer = 0; this.proposalObj.BeforeVATPremium = 0; this.proposalObj.VATAmount = 0;
    this.proposalObj.VATPercent = 0; this.proposalObj.TotalPremium = 0;

    for (let cover of this.proposalObj.Covers) {
      this.proposalObj.BasicPremium = this.proposalObj.BasicPremium + cover.BasicPremium;
      this.proposalObj.DeductableLoadPer = this.proposalObj.DeductableLoadPer + cover.DeductableLoadPer;
      this.proposalObj.DeductableLoadAmt = this.proposalObj.DeductableLoadAmt + cover.DeductableLoadAmt;
      this.proposalObj.ExtPeriodLoadPer = this.proposalObj.ExtPeriodLoadPer + cover.ExtPeriodLoadPer;
      this.proposalObj.ExtPeriodLoadAmt = this.proposalObj.ExtPeriodLoadAmt + cover.ExtPeriodLoadAmt;
      this.proposalObj.RetroDateLoadPer = this.proposalObj.RetroDateLoadPer + cover.RetroDateLoadPer;
      this.proposalObj.RetroDateLoadAmt = this.proposalObj.RetroDateLoadAmt + cover.RetroDateLoadAmt;
      this.proposalObj.AddRetroDateLoadPer = this.proposalObj.AddRetroDateLoadPer + cover.AddRetroDateLoadPer;
      this.proposalObj.AddRetroDateLoadAmt = this.proposalObj.AddRetroDateLoadAmt + cover.AddRetroDateLoadAmt;
      this.proposalObj.Grosspremium = this.proposalObj.Grosspremium + cover.GrossAmount;
      this.proposalObj.DiscountPercentage = this.proposalObj.DiscountPercentage + cover.User_Discount_Per;
      this.proposalObj.DiscountAmount = this.proposalObj.DiscountAmount + cover.User_Discount_Amount;
      this.proposalObj.CrossSellDiscountPer = this.proposalObj.CrossSellDiscountPer + cover.CorssSellDiscPer;
      this.proposalObj.CrossSellDiscountAmt = this.proposalObj.CrossSellDiscountAmt + cover.CorssSellDiscAmt;
      this.proposalObj.PromoDiscountPer = this.proposalObj.PromoDiscountPer + cover.PromoDiscountPer;
      this.proposalObj.PromoDiscount = this.proposalObj.PromoDiscount + cover.PromoDiscountAmount;
      this.proposalObj.BeforeVATPremium = this.proposalObj.BeforeVATPremium + cover.TotalPrice;
      if(cover.IsBasic)
      {
        this.proposalObj.VATPercent = this.proposalObj.VATPercent + cover.VatPer;
      }
      this.proposalObj.VATAmount = this.proposalObj.VATAmount + cover.VatAmount;
    }

    this.proposalObj.TotalPremium = this.proposalObj.BeforeVATPremium + this.proposalObj.VATAmount;
  }
}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/MedmalPortal/MedmalNewProposalConfirm/MedmalNewProposalConfirm.ts